import { Value } from '@philips-emr/tws-core';
import { registerValidator } from '@philips-emr/tws-core/lib/services/model-service';
import { validate } from '@philips-emr/tws-model/lib/formatters/date/date';

const VALIDATOR_NAME = 'prevent-future-date';

export default registerValidator(VALIDATOR_NAME, (value: Value) => {
  if (!value) {
    return [];
  }

  const currentDate = new Date();
  const minimumDate = new Date('1900-01-01');
  const valueDate = new Date(value as string);

  const isValidDate = validate(value)[0].valid;

  const valid = valueDate <= currentDate && valueDate >= minimumDate && isValidDate;

  return [{
    message: !valid ? 'tws.validator.invalid-date' : '',
    name: VALIDATOR_NAME,
    valid,
  }];
});
